import { CustomButton } from "../../components/customButton/CustomButton";
import CustomSwitch from "../../components/customSwitch/CustomSwitch";
import { Account, Documenatation } from "../../resources/assetsManager";
import { ButtonStyles } from "../../resources/stylesManager";

export const DeveloperSwitch = ({
  title,
  switchrequired,
  onSwitchChange,
  value,
}) => {
  return (
    <>
      <p
        style={{
          color: "black",
          fontSize: "16px",
          marginRight: "10px",
          fontWeight: "500",
        }}
        className="roboto"
      >
        {title}
      </p>
      {switchrequired && (
        <CustomSwitch onChange={onSwitchChange} value={value} />
      )}
    </>
  );
};

export const VirtualAccount = ({ title }) => {
  return (
    <>
      <img src={Account} alt="Virtual Account" />
      <p
        style={{
          color: "black",
          fontSize: "16px",
          margin: "0px 10px",
          fontWeight: "500",
        }}
        className="roboto"
      >
        {title}
      </p>
      <p
        style={{
          color: "#17AA40",
          fontSize: "16px",
          margin: "0px",
          fontWeight: "500",
        }}
        className="roboto"
      >
        Approved
      </p>
    </>
  );
};

export const DocumentationComponent = ({
  buttonTitle,
  icon,
  onButtonClicked,
}) => {
  return (
    <>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          marginRight: "30px",
          color: "black",
        }}
      >
        <p style={{ fontSize: "16px", marginRight: "10px" }} className="roboto">
          Documentation
        </p>
        <img
          src={Documenatation}
          style={{ cursor: "pointer" }}
          alt="document"
        />
      </div>
      <CustomButton
        icon={icon}
        styles={{ ...ButtonStyles, width: "auto" }}
        title={buttonTitle}
        onClick={onButtonClicked}
      />
    </>
  );
};

export const ApiDocument = ({ title, description }) => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        color: "black",
        fontFamily: "Roboto",
        lineHeight: "28px",
      }}
    >
      <p
        style={{
          fontSize: "16px",
          marginRight: "10px",
          fontWeight: "500",
          margin: 0,
          letterSpacing: "0%",
        }}
        className="roboto"
      >
        {title}
      </p>
      <p
        style={{ fontSize: "16px", margin: 0, marginLeft: "10px" }}
        className="roboto"
      >
        {description}
      </p>
    </div>
  );
};
